import { render, staticRenderFns } from "./ComplianceWorstPerformingBuildings.vue?vue&type=template&id=614bddf5&"
import script from "./ComplianceWorstPerformingBuildings.vue?vue&type=script&lang=ts&"
export * from "./ComplianceWorstPerformingBuildings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports